import script from "./TelaLogin.vue?vue&type=script&setup=true&lang=js"
export * from "./TelaLogin.vue?vue&type=script&setup=true&lang=js"

import "./TelaLogin.vue?vue&type=style&index=0&id=318d5b06&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-318d5b06"]])

export default __exports__